import { render, staticRenderFns } from "./DrugIssuedByMonthRep.vue?vue&type=template&id=295e8bcc&"
import script from "./DrugIssuedByMonthRep.vue?vue&type=script&lang=js&"
export * from "./DrugIssuedByMonthRep.vue?vue&type=script&lang=js&"
import style0 from "./DrugIssuedByMonthRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports